(function () {
  'use strict';

  var GENERIC_VERIFY_ERROR = "We couldn't verify your order right now. Please try again shortly or contact Lukzer Care.";
  var GENERIC_REGISTER_ERROR = "We couldn't register your warranty right now. Please try again shortly or contact Lukzer Care.";
  var GENERIC_CLAIM_ERROR = "We couldn't submit your warranty request right now. Please try again shortly or contact Lukzer Care.";
  var GENERIC_TRACK_ERROR = "We couldn't check your claim right now. Please try again shortly or contact Lukzer Care.";
  var SUPABASE_URL = 'https://pketeqfoijehknxtkclx.supabase.co';
  var SUPABASE_REGISTRATION_URL = SUPABASE_URL + '/rest/v1/rpc/register_warranty';
  var SUPABASE_CLAIM_URL = SUPABASE_URL + '/rest/v1/rpc/submit_claim';
  var SUPABASE_TRACK_URL = SUPABASE_URL + '/rest/v1/rpc/track_claim';
  var SUPABASE_CLAIM_UPLOAD_BUCKET = 'claim-uploads';
  var SUPABASE_CLAIM_UPLOAD_URL = SUPABASE_URL + '/storage/v1/object/' + SUPABASE_CLAIM_UPLOAD_BUCKET + '/';
  var PUBLISHABLE_KEY = 'sb_publishable_G8QzOI4ZtlPC5MKQ5ihsoA_mS9tbZu_';
  var MAX_CLAIM_FILE_SIZE = 10 * 1024 * 1024;

  function jsonRequest(payload) {
    return {
      method: 'POST',
      body: JSON.stringify(payload || {}),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    };
  }

  function postForm(form) {
    return {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    };
  }

  function fieldValue(form, name) {
    var field = form.elements[name];
    return field ? String(field.value || '').trim() : '';
  }

  function getCommonPayload(form) {
    return {
      fullName: fieldValue(form, 'full_name'),
      email: fieldValue(form, 'email'),
      mobile: fieldValue(form, 'mobile'),
      orderId: fieldValue(form, 'order_id'),
      modelNumber: fieldValue(form, 'model_number'),
      purchaseSource: fieldValue(form, 'purchase_source'),
      purchaseDate: fieldValue(form, 'purchase_date'),
      invoiceNumber: fieldValue(form, 'invoice_number')
    };
  }

  function getSupabaseRegistrationPayload(form) {
    var common = getCommonPayload(form);
    return {
      p_full_name: common.fullName,
      p_email: common.email,
      p_mobile: common.mobile,
      p_order_id: common.orderId,
      p_model_number: common.modelNumber,
      p_purchase_source: common.purchaseSource,
      p_purchase_date: common.purchaseDate,
      p_invoice_number: common.invoiceNumber
    };
  }

  function supabaseRegistrationRequest(form) {
    return supabaseRpcRequest(getSupabaseRegistrationPayload(form));
  }

  function supabaseRpcRequest(payload) {
    return {
      method: 'POST',
      body: JSON.stringify(payload || {}),
      credentials: 'omit',
      headers: {
        apikey: PUBLISHABLE_KEY,
        Authorization: 'Bearer ' + PUBLISHABLE_KEY,
        'Content-Type': 'application/json'
      }
    };
  }

  function getSupabaseClaimPayload(form, uploadUrls) {
    uploadUrls = uploadUrls || {};
    return {
      p_name: fieldValue(form, 'full_name'),
      p_email: fieldValue(form, 'email'),
      p_order_id: fieldValue(form, 'order_id'),
      p_issue: fieldValue(form, 'issue'),
      p_issue_type: fieldValue(form, 'issue_type'),
      p_photo_url: uploadUrls.photoUrls && uploadUrls.photoUrls.length ? uploadUrls.photoUrls.join(',') : null,
      p_video_url: uploadUrls.videoUrl || null,
      p_invoice_url: uploadUrls.invoiceUrl || null
    };
  }

  function getSupabaseTrackPayload(form) {
    return {
      p_ref: fieldValue(form, 'claim_id')
    };
  }

  function request(endpoint, options, fallbackMessage) {
    if (!endpoint) {
      return Promise.resolve({ ok: false, placeholder: true, message: fallbackMessage || GENERIC_VERIFY_ERROR });
    }

    return fetch(endpoint, options).then(function (response) {
      return response.json().catch(function () {
        return { success: response.ok };
      }).then(function (body) {
        if (!response.ok) return body;
        return body;
      });
    }).catch(function () {
      if (window.console && window.console.info) {
        window.console.info('[LukzerWarranty] Service unavailable or not configured yet.');
      }
      return { ok: false, placeholder: true, message: fallbackMessage || GENERIC_VERIFY_ERROR };
    });
  }

  var LukzerWarrantyAPI = {
    registerWarranty: function (form) {
      return request(SUPABASE_REGISTRATION_URL, supabaseRegistrationRequest(form), GENERIC_REGISTER_ERROR).then(function (result) {
        if (Array.isArray(result)) return { success: true, registration: result[0] || {} };
        return result;
      });
    },
    submitClaim: function (form) {
      return uploadClaimFiles(form).then(function (uploadUrls) {
        return request(SUPABASE_CLAIM_URL, supabaseRpcRequest(getSupabaseClaimPayload(form, uploadUrls)), GENERIC_CLAIM_ERROR);
      });
    },
    trackClaim: function (form) { return request(SUPABASE_TRACK_URL, supabaseRpcRequest(getSupabaseTrackPayload(form)), GENERIC_TRACK_ERROR); }
  };

  function setLoading(button, loading, fallbackText) {
    if (!button) return;
    if (loading) {
      button.dataset.originalText = button.textContent;
      button.textContent = button.dataset.loadingLabel || fallbackText || 'Please wait...';
      button.disabled = true;
    } else {
      button.textContent = button.dataset.originalText || button.textContent;
      button.disabled = false;
    }
  }

  function setMessage(root, text, type) {
    var message = root.querySelector('[data-lukzer-message]');
    if (!message) return;
    message.textContent = text || '';
    message.classList.toggle('is-error', type === 'error');
    message.classList.toggle('is-success', type === 'success');
  }

  function setFileError(field, text) {
    var label = field.closest('label');
    var error = label ? label.querySelector('[data-lukzer-file-error]') : null;
    field.setCustomValidity(text || '');
    if (error) {
      error.textContent = text || '';
      error.hidden = !text;
    }
  }

  function formatWarrantyDate(value) {
    if (!value) return '';
    var parts = String(value).split('-');
    if (parts.length !== 3) return String(value);
    var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  function registrationSuccessMessage(registration) {
    if (registration && registration.warranty_expiry) {
      return 'Your Lukzer product is covered under warranty until ' + formatWarrantyDate(registration.warranty_expiry) + '.';
    }
    return "we're confirming your purchase details and will email your warranty confirmation shortly (usually within an hour).";
  }

  function registrationSuccessTitle(registration) {
    if (registration && registration.warranty_expiry) {
      return 'Warranty Registered Successfully';
    }
    return "We've received your request";
  }

  function visibleFieldsValid(root) {
    var fields = Array.prototype.slice.call(root.querySelectorAll('input, select, textarea')).filter(function (field) {
      return !field.disabled && !field.closest('[hidden]') && field.type !== 'hidden';
    });
    return fields.every(function (field) {
      var message = field.dataset.validationMessage || 'Please complete this field.';
      field.setCustomValidity('');

      if (field.matches('[data-lukzer-mobile-10]') && !validIndianMobile(field)) {
        field.setCustomValidity(message);
        field.reportValidity();
        return false;
      }

      if (field.matches('[data-lukzer-file-kind]')) {
        var fileError = validateClaimFileInput(field);
        if (fileError) {
          setFileError(field, fileError);
          field.reportValidity();
          return false;
        }
        setFileError(field, '');
      }

      if (field.type === 'email' && field.value.trim() && !field.checkValidity()) {
        field.setCustomValidity(message);
        field.reportValidity();
        return false;
      }

      if (field.hasAttribute('required') && !field.value.trim()) {
        field.setCustomValidity(message);
        field.reportValidity();
        return false;
      }

      return field.reportValidity();
    });
  }

  function validIndianMobile(field) {
    var value = field.value.replace(/\D/g, '').slice(0, 10);
    field.value = value;
    return value.length === 10;
  }

  function initMobileValidation(root) {
    root.addEventListener('input', function (event) {
      if (!event.target.matches('[data-lukzer-mobile-10]')) return;
      event.target.value = event.target.value.replace(/\D/g, '').slice(0, 10);
      event.target.setCustomValidity('');
    });
  }

  function initClaimFileValidation(form) {
    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-lukzer-file-kind]')) return;
      setFileError(event.target, validateClaimFileInput(event.target));
    });
  }

  function validateClaimFileInput(field) {
    var files = Array.prototype.slice.call(field.files || []);
    var kind = field.getAttribute('data-lukzer-file-kind');
    if (field.hasAttribute('required') && files.length === 0) {
      return field.dataset.validationMessage || 'Please upload the required file.';
    }
    if (kind !== 'photos' && files.length > 1) {
      return 'Please upload only one file here.';
    }
    for (var index = 0; index < files.length; index += 1) {
      var file = files[index];
      if (file.size > MAX_CLAIM_FILE_SIZE) {
        return file.name + ' is larger than 10 MB.';
      }
      if (!isAllowedClaimFile(file, kind)) {
        if (kind === 'photos') return file.name + ' must be an image file.';
        if (kind === 'video') return file.name + ' must be an MP4, MOV, or WebM video.';
        if (kind === 'invoice') return file.name + ' must be an image or PDF.';
      }
    }
    return '';
  }

  function isAllowedClaimFile(file, kind) {
    var type = String(file.type || '').toLowerCase();
    var extension = file.name.split('.').pop().toLowerCase();
    var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif'];
    var isImage = type.indexOf('image/') === 0 || imageExtensions.indexOf(extension) !== -1;
    if (kind === 'photos') return isImage;
    if (kind === 'video') return type === 'video/mp4' || type === 'video/quicktime' || type === 'video/webm' || extension === 'mp4' || extension === 'mov' || extension === 'webm';
    if (kind === 'invoice') return isImage || type === 'application/pdf' || extension === 'pdf';
    return true;
  }

  function uploadClaimFiles(form) {
    var photoField = form.elements.product_photos;
    var videoField = form.elements.video;
    var invoiceField = form.elements.invoice;
    var photos = Array.prototype.slice.call(photoField && photoField.files ? photoField.files : []);
    var video = videoField && videoField.files && videoField.files[0] ? videoField.files[0] : null;
    var invoice = invoiceField && invoiceField.files && invoiceField.files[0] ? invoiceField.files[0] : null;

    return Promise.all(photos.map(uploadClaimFile)).then(function (photoUrls) {
      return Promise.all([video ? uploadClaimFile(video) : Promise.resolve(null), invoice ? uploadClaimFile(invoice) : Promise.resolve(null)]).then(function (singleUrls) {
        return {
          photoUrls: photoUrls,
          videoUrl: singleUrls[0],
          invoiceUrl: singleUrls[1]
        };
      });
    });
  }

  function uploadClaimFile(file) {
    var path = buildClaimFilePath(file.name);
    return fetch(SUPABASE_CLAIM_UPLOAD_URL + encodeClaimPath(path), {
      method: 'POST',
      body: file,
      credentials: 'omit',
      headers: {
        apikey: PUBLISHABLE_KEY,
        Authorization: 'Bearer ' + PUBLISHABLE_KEY,
        'Content-Type': file.type || 'application/octet-stream'
      }
    }).then(function (response) {
      if (response.ok) {
        return SUPABASE_URL + '/storage/v1/object/public/' + SUPABASE_CLAIM_UPLOAD_BUCKET + '/' + path;
      }
      return response.text().then(function (body) {
        throw new Error(uploadErrorMessage(body));
      });
    });
  }

  function buildClaimFilePath(filename) {
    return 'claims/' + Date.now() + '-' + Math.random().toString(36).slice(2, 10) + '-' + safeFilename(filename);
  }

  function safeFilename(filename) {
    return String(filename || 'upload')
      .trim()
      .replace(/[^a-zA-Z0-9._-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 120) || 'upload';
  }

  function encodeClaimPath(path) {
    return path.split('/').map(encodeURIComponent).join('/');
  }

  function uploadErrorMessage(body) {
    if (!body) return 'One of the files could not be uploaded. Please try again.';
    try {
      var parsed = JSON.parse(body);
      return parsed.message || parsed.error || 'One of the files could not be uploaded. Please try again.';
    } catch (error) {
      return 'One of the files could not be uploaded. Please try again.';
    }
  }

  function initRegister(form) {
    initMobileValidation(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!visibleFieldsValid(form)) return;
      var button = event.submitter || form.querySelector('button[type="submit"]');
      var success = form.querySelector('[data-lukzer-register-success]');
      setLoading(button, true);
      LukzerWarrantyAPI.registerWarranty(form).then(function (result) {
        if (result && (result.success || result.ok)) {
          if (success) success.hidden = false;
          var registration = result.registration || {};
          var registrationId = form.querySelector('[data-lukzer-registration-id]');
          var registrationTitle = form.querySelector('[data-lukzer-register-success-title]');
          if (registrationTitle) registrationTitle.textContent = registrationSuccessTitle(registration);
          if (registrationId) registrationId.textContent = registration.id || result.registrationId || 'Provided after submission';
          setMessage(form, registrationSuccessMessage(registration), 'success');
        } else {
          if (success) success.hidden = true;
          setMessage(form, result.message || GENERIC_REGISTER_ERROR, 'error');
        }
      }).finally(function () {
        setLoading(button, false);
      });
    });
  }

  function initClaim(form) {
    initClaimFileValidation(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!visibleFieldsValid(form)) return;
      var button = event.submitter || form.querySelector('button[type="submit"]');
      var success = form.querySelector('[data-lukzer-claim-success]');
      setLoading(button, true);
      LukzerWarrantyAPI.submitClaim(form).then(function (result) {
        if (typeof result === 'string' && result) {
          if (success) success.hidden = false;
          var claimId = form.querySelector('[data-lukzer-claim-id]');
          if (claimId) claimId.textContent = result;
          hideClaimFormControls(form);
          setMessage(form, '', 'success');
        } else {
          if (success) success.hidden = true;
          setMessage(form, result.message || GENERIC_CLAIM_ERROR, 'error');
        }
      }).catch(function (error) {
        if (success) success.hidden = true;
        setMessage(form, error.message || GENERIC_CLAIM_ERROR, 'error');
      }).finally(function () {
        if (success && !success.hidden) return;
        setLoading(button, false);
      });
    });
  }

  function initTrack(form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!visibleFieldsValid(form)) return;
      var button = event.submitter || form.querySelector('button[type="submit"]');
      setLoading(button, true);
      LukzerWarrantyAPI.trackClaim(form).then(function (result) {
        if (Array.isArray(result) && result.length > 0) {
          renderClaimResult(form, result);
          setMessage(form, '', 'success');
        } else if (Array.isArray(result)) {
          renderClaimResult(form, [], 'No claim found with that ID.');
          setMessage(form, 'No claim found with that ID.', 'error');
        } else {
          renderClaimResult(form, null);
          setMessage(form, result.message || GENERIC_TRACK_ERROR, 'error');
        }
      }).finally(function () {
        setLoading(button, false);
      });
    });
  }

  function renderOrders(form, orders) {
    var results = form.querySelector('[data-lukzer-order-results]');
    var empty = form.querySelector('[data-lukzer-order-empty]');
    if (!results) return;
    results.textContent = '';
    if (!orders.length) {
      if (empty) {
        empty.hidden = false;
        empty.textContent = "We couldn't find an eligible Lukzer order for this number.";
      }
      return;
    }
    if (empty) empty.hidden = true;
    orders.forEach(function (order, index) {
      var label = document.createElement('label');
      label.className = 'lukzer-warranty-order';
      label.innerHTML = [
        '<input type="radio" name="selected_product" value="' + escapeAttr(order.variantId || order.productId || index) + '"' + (index === 0 ? ' required' : '') + '>',
        order.productImage ? '<img class="lukzer-warranty-order-image" src="' + escapeAttr(order.productImage) + '" alt="">' : '<span class="lukzer-warranty-order-image" aria-hidden="true"></span>',
        '<span><b>Product title</b><small>' + escapeHtml(order.productTitle) + '</small></span>',
        '<span><b>Order ID</b><small>' + escapeHtml(order.orderId) + '</small></span>',
        '<span><b>SKU</b><small>' + escapeHtml(order.sku) + '</small></span>',
        '<span><b>Variant</b><small>' + escapeHtml(order.variantTitle) + '</small></span>',
        '<span><b>Purchase date</b><small>' + escapeHtml((order.purchaseDate || '').slice(0, 10)) + '</small></span>',
        '<span><b>Quantity</b><small>' + escapeHtml(order.quantity) + '</small></span>'
      ].join('');
      results.appendChild(label);
    });
  }

  function hideClaimFormControls(form) {
    var grid = form.querySelector('.lukzer-warranty-grid');
    var button = form.querySelector('button[type="submit"]');
    if (grid) grid.hidden = true;
    if (button) button.hidden = true;
  }

  function renderClaimResult(form, claim, emptyText) {
    var target = form.querySelector('[data-lukzer-claim-result]');
    if (!target) return;
    var claims = Array.isArray(claim) ? claim : (claim ? [claim] : []);
    if (!claims.length) {
      target.hidden = !emptyText;
      target.textContent = emptyText || '';
      return;
    }
    target.hidden = false;
    target.innerHTML = claims.map(function (item) {
      var claimId = item.claim_ref || item.claim_id || item.claimId || item.id || '';
      var status = item.status || item.current_status || item.currentStatus || '';
      var issueType = item.issue_type || item.issueType || '';
      var issue = item.issue_text || item.issue || item.p_issue || item.issue_description || item.issueDescription || '';
      var created = formatReadableDate(item.created_at || item.createdAt || item.submitted_on || item.submittedOn || '');
      return [
        '<article class="lukzer-warranty-claim-result__item">',
        '<h3>Claim</h3>',
        '<dl>',
        '<div><dt>Claim:</dt><dd>' + escapeHtml(claimId) + '</dd></div>',
        '<div><dt>Status:</dt><dd>' + escapeHtml(status) + '</dd></div>',
        '<div><dt>Issue type:</dt><dd>' + escapeHtml(issueType) + '</dd></div>',
        '<div><dt>Issue:</dt><dd>' + escapeHtml(issue) + '</dd></div>',
        '<div><dt>Submitted on:</dt><dd>' + escapeHtml(created) + '</dd></div>',
        '</dl>',
        '</article>'
      ].join('');
    }).join('');
  }

  function formatReadableDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function initAccordions(root) {
    Array.prototype.forEach.call(root.querySelectorAll('details'), function (detail) {
      var summary = detail.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      detail.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      });
    });
  }

  function isValidView(view) {
    return view === 'register' || view === 'claim' || view === 'track' || view === 'policy';
  }

  function switchView(root, view, options) {
    options = options || {};
    view = isValidView(view) ? view : 'register';
    document.documentElement.setAttribute('data-lukzer-warranty-tab', view);
    var panelsWrap = root.querySelector('[data-lukzer-warranty-panels]');
    if (panelsWrap) panelsWrap.hidden = false;

    Array.prototype.forEach.call(root.querySelectorAll('[data-lukzer-warranty-view-button]'), function (button) {
      var active = button.getAttribute('data-lukzer-warranty-view-button') === view;
      button.classList.toggle('is-active', active);
      if (button.tagName === 'A') {
        button.removeAttribute('aria-pressed');
        if (active) {
          button.setAttribute('aria-current', 'page');
        } else {
          button.removeAttribute('aria-current');
        }
      } else {
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-lukzer-warranty-view]'), function (panel) {
      var active = panel.getAttribute('data-lukzer-warranty-view') === view;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active && options.scroll === true) {
        scrollPanelIntoView(panel);
      }
    });

    if (options.syncUrl !== false && window.history && window.URLSearchParams) {
      var url = new URL(window.location.href);
      url.searchParams.set('tab', view);
      window.history.pushState({ lukzerWarrantyTab: view }, '', url.pathname + url.search + url.hash);
    }
  }

  function scrollPanelIntoView(panel) {
    var header = document.querySelector('.shopify-section-header-sticky, sticky-header, header[role="banner"], .site-header, .nov-header, #header');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var spacing = 26;
    var top = panel.getBoundingClientRect().top + window.pageYOffset - headerHeight - spacing;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'auto' });
  }

  function openFromUrl(root) {
    var params = new URLSearchParams(window.location.search);
    var requested = params.get('tab');
    switchView(root, isValidView(requested) ? requested : 'register', { scroll: false, syncUrl: false });
    root.classList.add('is-tabbed');
  }

  function initRoot(root) {
    if (root.dataset.lukzerWarrantyInitialized === 'true') return;
    root.dataset.lukzerWarrantyInitialized = 'true';

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lukzer-warranty-view-button]');
      if (!button || !root.contains(button)) return;
      if (button.tagName === 'A') event.preventDefault();
      switchView(root, button.getAttribute('data-lukzer-warranty-view-button'));
    });

    openFromUrl(root);

    var register = root.querySelector('[data-lukzer-register-form]');
    var claim = root.querySelector('[data-lukzer-claim-form]');
    var track = root.querySelector('[data-lukzer-track-form]');
    if (register) initRegister(register);
    if (claim) initClaim(claim);
    if (track) initTrack(track);
    initAccordions(root);

    root._lukzerWarrantyPopstate = function () {
      openFromUrl(root);
    };
    window.addEventListener('popstate', root._lukzerWarrantyPopstate);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lukzer-warranty]'), initRoot);
  }

  function unload(event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-lukzer-warranty]') : null;
    if (!root || !root._lukzerWarrantyPopstate) return;
    window.removeEventListener('popstate', root._lukzerWarrantyPopstate);
    root._lukzerWarrantyPopstate = null;
    delete root.dataset.lukzerWarrantyInitialized;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', unload);

  window.LukzerWarrantyAPI = LukzerWarrantyAPI;
  window.LukzerWarranty = {
    api: LukzerWarrantyAPI,
    switchView: switchView
  };
})();
